<template>
  <div class="sn-bs-box-panel sn-bs-box-panel__bg">
    <div class="sn-bs-box-panel__title">
      <slot name="title">
        <p class="sn-bs-box-panel__title-inner sn-bs-box-panel__title-bg">
          {{ title }}
        </p>
        <el-button
          v-if="showRightButton"
          class="sn-bs-box-panel__head-btn--right"
          type="text"
          @click="handleRight"
          >{{ rightButtonContext }} <i class="el-icon-d-arrow-right"></i
        ></el-button>
      </slot>
    </div>
    <div class="sn-bs-box-panel__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BsBoxPanel",
  props: {
    title: {
      type: String,
      default: "",
    },
    showRightButton: {
      type: Boolean,
      default: false,
    },
    rightButtonContext: {
      type: String,
      default: "更多",
    },
  },
  methods: {
    handleRight() {
      this.$emit("on-right");
    },
  },
};
</script>

<style scoped lang="scss">
@include bs(box-panel) {
  width: 369px;
  height: 301px;
  box-sizing: border-box;
  @include e(bg) {
    background: url("~@/assets/images/bs/info-panel-block-bg.png") no-repeat;
    background-size: 100% 100%;
    padding: 8px 20px 20px 10px;
  }
  @include e(title) {
    height: 40px;
    color: #32c375;
    position: relative;
  }
  @include e(title-inner) {
    position: relative;
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
    text-align: center;
  }
  @include e(head-btn) {
    @include m(right) {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: $--font-size-base;
      color: #16e592;
      opacity: 0.5;
      z-index: 1;
    }
  }
  @include e(title-bg) {
    position: relative;
    z-index: 1;
    &::before {
      @include utils-full-box();
      content: "";
      position: absolute;
      left: 0;
      top: 15px;
      background: url("~@/assets/images/bs/info-panel-block-title-block.png")
        no-repeat center bottom;
      background-size: 100% 100%;
    }
  }
  @include e(body) {
    position: relative;
    z-index: 2;
    height: calc(100% - 40px);
    color: $--color-white;
  }
}
</style>
